import Vue from 'vue'
import Vuex from 'vuex'

import common from "./modules/common.js"
import goods from "./modules/goods.js"
import user from "./modules/user.js"
import menu from "./modules/menu.js"
import setting from "./modules/setting.js"

Vue.use(Vuex)

export default new Vuex.Store({
	modules:{
		common,
		goods,
		user,
		menu,
		setting,
	}
})